module.exports = __webpack_public_path__ + "static/music-republicain-2-acb7d2f0526f9800dbfea128bc3a094f.jpg";